import { render, staticRenderFns } from "./IndicatorQueue.vue?vue&type=template&id=19c37180&"
import script from "./IndicatorQueue.vue?vue&type=script&lang=ts&"
export * from "./IndicatorQueue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports